"use strict";
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.observe = exports.Observable = void 0;
class Observable {
    constructor(value) {
        this._listener = [];
        this.get = () => this._value;
        this.set = (newValue) => {
            const oldValue = this._value;
            if (this.willUpdate(oldValue, newValue) === false)
                return this;
            this._value = newValue;
            if (this.shouldCallListener(oldValue, newValue) === false)
                return this;
            this._listener.forEach((f) => f === null || f === void 0 ? void 0 : f(newValue));
            this.didUpdate(oldValue, newValue);
            return this;
        };
        this.listen = (callback) => {
            let i = Math.random() * 100 | 0;
            let mask = 1;
            let tryied = 0;
            while (this._listener[i]) {
                if (tryied === 5) {
                    tryied = 0;
                    mask++;
                }
                i = Math.random() * Math.pow(100, mask) | 0;
                tryied++;
            }
            this._listener[i] = callback;
            return () => this._listener[i] = null;
        };
        this.change = (timeout = 0, enforce = false) => {
            const promise = new Promise((resolve, reject) => {
                const unsub = this.listen((value) => {
                    unsub();
                    resolve(value);
                });
                if (timeout) {
                    setTimeout(() => {
                        unsub();
                        enforce ? reject(new Error("Observable: Timeout on change")) : resolve(null);
                    }, timeout);
                }
            });
            return promise;
        };
        this.willUpdate = () => true;
        this.shouldCallListener = () => true;
        this.didUpdate = () => true;
        this._value = value;
    }
}
exports.Observable = Observable;
function observe(obs, timeout = 0, enforce = false) {
    return __asyncGenerator(this, arguments, function* observe_1() {
        while (true)
            yield yield __await(yield __await(obs.change(timeout, enforce)));
    });
}
exports.observe = observe;
//# sourceMappingURL=observable.js.map